import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type SuggestedPersonFragment = {
	__typename?: 'Person';
	id: string;
	objectType: Types.ObjectType;
	objectId: number;
	content: { __typename?: 'PersonContent'; fullName: string; dateOfBirth?: any | null; portraitUrl?: string | null };
};

export const SuggestedPersonFragmentDoc = gql`
	fragment SuggestedPerson on Person {
		id
		objectType
		objectId
		content(country: $country, language: $language) {
			fullName
			dateOfBirth
			portraitUrl(profile: S332)
		}
	}
`;
